module.exports = __webpack_public_path__ + "static/media/Laura.a0df14ef.jpg";